// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/priority-status-calls.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/priority-status-calls/priority-status-calls.js';

mount([g0]);
